import Vue from 'vue'
import bst from 'bootstrap.native/dist/bootstrap-native-v4';

Object.defineProperty(Vue.prototype, '$bst', { value: bst });
